/**
 * 配置编译环境和线上环境之间的切换
 *
 * h5Url: web页面域名地址
 * baseUrl: api域名地址
 * routerMode: 路由模式
 * imgBaseUrl: 图片所在域名地址
 *
 */
let baseUrl = ''
if (process.env.NODE_ENV === 'development') {
  // 开发环境api域名地址
  baseUrl = 'http://jsnh.g-idea.net'
} else if (process.env.NODE_ENV === 'test') {
  // 测试环境api域名地址
  baseUrl = 'http://jsnh.g-idea.net'
} else if (process.env.NODE_ENV === 'production') {
  // 正式环境api域名地址
  baseUrl = 'http://golden-years.com.cn'
}

export {
  baseUrl
}
